import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row opening-day" }
const _hoisted_2 = { class: "col-md-2" }
const _hoisted_3 = { class: "col-md-5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { for: "{{day}}-opening-hour" }, "Opening hour", -1)
const _hoisted_5 = { class: "col-md-5" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "{{day}}-closing-hour" }, "Closing hour", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h5", null, _toDisplayString(_ctx.day), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("select", {
        "data-placeholder": "Opening Time",
        onChange: _cache[1] || (_cache[1] = ($event: any) => (this.$emit('update:openingHour', $event.target.value))),
        value: _ctx.openingHour,
        id: "{{day}}-opening-hour"
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hours(), (hour) => {
          return (_openBlock(), _createBlock("option", {
            key: hour,
            value: hour
          }, _toDisplayString(hour), 9, ["value"]))
        }), 128))
      ], 40, ["value"])
    ]),
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode("select", {
        "data-placeholder": "Closing Time",
        onChange: _cache[2] || (_cache[2] = ($event: any) => (this.$emit('update:closingHour', $event.target.value))),
        value: _ctx.closingHour,
        id: "{{day}}-closing-hour"
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hours(), (hour) => {
          return (_openBlock(), _createBlock("option", {
            type: "number",
            key: hour,
            value: hour
          }, _toDisplayString(hour), 9, ["value"]))
        }), 128))
      ], 40, ["value"])
    ])
  ]))
}